/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Nav_ListingsInputs */

const en_seller_nav_listings = /** @type {(inputs: Seller_Nav_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listings`)
};

const es_seller_nav_listings = /** @type {(inputs: Seller_Nav_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anuncios`)
};

const fr_seller_nav_listings = /** @type {(inputs: Seller_Nav_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annonces`)
};

const de_seller_nav_listings = /** @type {(inputs: Seller_Nav_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserate`)
};

const ja_seller_nav_listings = /** @type {(inputs: Seller_Nav_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出品`)
};

const zh_seller_nav_listings = /** @type {(inputs: Seller_Nav_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商品`)
};

const ar_seller_nav_listings = /** @type {(inputs: Seller_Nav_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإعلانات`)
};

const id_seller_nav_listings = /** @type {(inputs: Seller_Nav_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing`)
};

const it_seller_nav_listings = /** @type {(inputs: Seller_Nav_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annunci`)
};

const ru_seller_nav_listings = /** @type {(inputs: Seller_Nav_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объявления`)
};

const pt_seller_nav_listings = /** @type {(inputs: Seller_Nav_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anúncios`)
};

const ko_seller_nav_listings = /** @type {(inputs: Seller_Nav_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상품 관리`)
};

/**
* | output |
* | --- |
* | "Listings" |
*
* @param {Seller_Nav_ListingsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_nav_listings = /** @type {((inputs?: Seller_Nav_ListingsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Nav_ListingsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_nav_listings(inputs)
	if (locale === "es") return es_seller_nav_listings(inputs)
	if (locale === "fr") return fr_seller_nav_listings(inputs)
	if (locale === "de") return de_seller_nav_listings(inputs)
	if (locale === "ja") return ja_seller_nav_listings(inputs)
	if (locale === "zh") return zh_seller_nav_listings(inputs)
	if (locale === "ar") return ar_seller_nav_listings(inputs)
	if (locale === "id") return id_seller_nav_listings(inputs)
	if (locale === "it") return it_seller_nav_listings(inputs)
	if (locale === "ru") return ru_seller_nav_listings(inputs)
	if (locale === "pt") return pt_seller_nav_listings(inputs)
	return ko_seller_nav_listings(inputs)
});